import React from "react";
import PropTypes from "prop-types";
import Tab from "./tab";

const propTypes = {
  activeTab: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
};

const TabsContainer = ({ activeTab, tabs, onClick }) => (
  <div className="grid grid-cols-2 border-b border-light-grey">
    {tabs.map((tab) => (
      <Tab
        key={tab}
        tab={tab}
        active={activeTab === tab}
        onClick={() => onClick(tab)}
      />
    ))}
  </div>
);

TabsContainer.propTypes = propTypes;

export default TabsContainer;
